import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  keynamesArray: [],
};

const keysSlice = createSlice({
  name: 'keys',
  initialState,
  reducers: {
    addKeyname: (state, action) => {
      state.keynamesArray = [...state.keynamesArray, action.payload];
    },
  }
});

export const { keynamesArray } = keysSlice.actions;
export default keysSlice.reducer;

export const selectKeynames = (state) => state.keys.keynamesArray;

